module.exports = __webpack_public_path__ + "static/media/academic-endeavors--resized.2d993dac.jpg";